import PinInput from './PinInput';

export default PinInput;
